import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  @Input() isExpanded = true;
  @Output() toggleSidebar = new EventEmitter<void>();
  private userSub!: Subscription;
  menuItems: any[] = [];
  
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.userSub = this.authService.onUserChange().subscribe(user => {
      this.montarMenu(user);
    });
  }

  montarMenu(user: any) {
    let allItems = [
      { icon: 'bi bi-speedometer2', label: 'Dashboard', route: '/dashboard/ordens-servico', exact: true, adminOnly: false },
      { icon: 'bi bi-file-earmark-text', label: 'Ordens de Serviço', route: '/budget/list', exact: true, adminOnly: false },
      { icon: 'bi bi-people', label: 'Permissões de Usuários', route: '/users/list', exact: true, adminOnly: true },
    ];
    
    if (!user) {
      allItems = [
        { icon: 'bi bi-people', label: 'Login', route: '/auth/login', exact: true, adminOnly: false },]
    }

    this.menuItems = allItems.filter(item => {
      if (item.adminOnly) {
        return user?.tipo === 'admin';
      }
      return true;
    });
  }

  handleToggle() {
    this.toggleSidebar.emit();
  }
  
  logout() {
    this.authService.logout().subscribe(() => {
      this.router.navigate(['/auth/login']);
      this.authService.notifyLogin(null);
    });
  }
}